import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate } from 'react-router-dom';
import { NewTypePracticeCrubs } from 'practice/constants/type-practice-crubs';
import FormTypePractice, { FormTypePracticeVM } from 'practice/components/type-practice/form';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { AxiosPromise } from 'axios';

const NewTypePractice = (): ReactElement => {
  const navigate = useNavigate();

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-tipo-pratica');
  });

  const insertPractice = useHttpClient(`${__PRACTICE_API_URL__}/pratiche/tipo-pratica/`, {
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useCallback(
    (values: FormTypePracticeVM) => {
      const dataInsert = insertPractice({
        data: {
          tipoRegistro: values.typeRegister || undefined,
          descrizioneBreveTipoPratica: values.descriptionBrief || undefined,
          descrizioneTipoPratica: values.description || undefined,
          tipoIniziativa: values.typeInitiative || undefined,
          unitaMisuraTempo: values.measure || undefined,
          tempoStandard: values.timeStandard
            ? Number.parseInt(values.timeStandard?.toString())
            : undefined,
          tempoMax: values.timeMax ? Number.parseInt(values.timeMax?.toString()) : undefined,
          key: {
            tipoPratica: values.code,
          },
        },
      }) as AxiosPromise;
      dataInsert.then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/pratiche/ricerca-tipo-pratica');
      });
    },
    [insertPractice, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={NewTypePracticeCrubs} />
      <FormTypePractice
        title="Nuovo Tipo Pratica"
        onCancel={onCancel}
        onSubmit={onSubmit}
        required
      />
    </Fragment>
  );
};

NewTypePractice.displayName = 'New Type Practice Page component';

export default NewTypePractice;
